<template>
	<v-dialog v-model="showDialog" max-width="400" persistent>
		<v-card>
			<v-card-title> Add Static Field </v-card-title>
			<v-card-text>
				<v-form ref="form">
					<v-text-field v-model="formStaticField.Name" label="Name" />
				</v-form>
			</v-card-text>
			<v-divider />
			<v-card-actions>
				<v-btn @click.stop="onClose">Close</v-btn>
				<v-spacer />
				<v-btn color="primary" @click.stop="onSave">Save</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>
<script>
import { mapGetters } from 'vuex';
import { ActivityStaticFieldsActions } from '../../../../store/actions';
import { ActivityStaticFieldsGetters } from '../../../../store/getters';
export default {
	name: 'ActivityStaticFieldModal',
	props: {
		showDialog: Boolean,
	},
	computed: {
		...mapGetters({
			selectedStaticField: [
				ActivityStaticFieldsGetters.SELECTED_STATIC_FIELD,
			],
		}),
		formStaticField() {
			return Object.assign({}, this.selectedStaticField);
		},
	},
	methods: {
		onClose() {
			this.$store.dispatch(
				ActivityStaticFieldsActions.SET_SELECTED_STATIC_FIELD,
				null
			);
			this.$emit('close');
		},
		onSave() {
			if (this.formStaticField.Id) {
				if (this.$refs.form.validate()) {
					this.$store
						.dispatch(
							ActivityStaticFieldsActions.UPDATE_STATIC_FIELD,
							this.formStaticField
						)
						.then(() => {
							this.$store.dispatch(
								ActivityStaticFieldsActions.SET_SELECTED_STATIC_FIELD,
								null
							);
							this.$emit('close');
						});
				}
			} else {
				this.formStaticField.ActivityId = this.$route.params.id;
				if (this.$refs.form.validate()) {
					this.$store
						.dispatch(
							ActivityStaticFieldsActions.INSERT_STATIC_FIELD,
							this.formStaticField
						)
						.then(() => {
							this.$store.dispatch(
								ActivityStaticFieldsActions.SET_SELECTED_STATIC_FIELD,
								null
							);
							this.$emit('close');
						});
				}
			}
		},
	},
};
</script>
